module.exports = __webpack_public_path__ + "static/media/linked_in.8f5e2e23.svg";